export const defaultHtml =
  "<p style='text-align: center'>Edit the HTML code to add your custom HTML snippet.</p>";